import { apis } from "../../../backend";


/**
 * Creates a comment associated with a contact.
 * @param contactId ID of the contact.
 * @param message Comment message.
 */
export async function createContactComment(contactId: string, message: string): Promise<{ commentId: string }> {
  const { commentId } = await apis.contacts.post(`/contacts-v1/${contactId}/comments`, { message });
  return { commentId };
}

/**
 * Deletes a comment associated with a contact.
 * @param contactId ID of the contact.
 * @param commentId ID of the comment.
 */
export async function deleteContactComment(contactId: string, commentId: string) {
  await apis.contacts.del(`/contacts-v1/${contactId}/comments/${commentId}`);
}